/**
 * The one check of what may become a link (decision 44: http, https and mailto, nothing else; part 41a, table L rows
 * L1–L5). Every place that turns content into a link asks it: the DOCX importer (L1), rich paste (L2), the typed and pasted URL
 * shortcuts (L3) and the EPUB and DOCX exports (L4, L5). Pure.
 */

/** Decision 44: the schemes a link may have, as the WHATWG parser writes them. */
const LINK_SCHEMES: ReadonlySet<string> = new Set(['http:', 'https:', 'mailto:']);

/**
 * Decision 44 (table L; part 20's H3a and H3i): the URL `destination` names when it may be a link, or null. It may when
 * it parses as a WHATWG URL with no base (so no relative path, no protocol-relative `//x`, no percent-encoded scheme),
 * its scheme is http, https or mailto in any case, and the text starts with that scheme as it reads (the parser drops
 * leading blanks and controls and every tab or line end, so `java\tscript:` and `\u0001http:` are never read as another
 * scheme than they show); a mailto must name something (H3i). Callers trim what they must; this never does.
 */
export function allowedLink(destination: string): URL | null {
  let url: URL;
  try {
    url = new URL(destination);
  } catch {
    return null;
  }
  if (!LINK_SCHEMES.has(url.protocol) || destination.slice(0, url.protocol.length).toLowerCase() !== url.protocol) return null;
  if (url.protocol === 'mailto:' && url.pathname === '') return null;
  return url;
}

/** Decision 44 (table L): whether `destination` may be a link, as {@link allowedLink} decides. */
export function isAllowedLink(destination: string): boolean {
  return allowedLink(destination) !== null;
}
